module.exports = __webpack_public_path__ + "media/img/up-black-3ef37af8f461b54400d59ad595bbbe6d.svg";